module.exports = __webpack_public_path__ + "img/1518032057.18f36e47.jpg";